import * as Sentry from '@sentry/react';
import { defaultConfig } from 'app/config/environment';

export const SENTRY_RELEASE = process.env.REACT_APP_VERSION;

export function initSentry() {
  const { DOMAIN } = defaultConfig;
  const dsn = process.env.REACT_APP_API_CONFIG_SENTRY;

  if (dsn) {
    Sentry.init({
      dsn,
      release: SENTRY_RELEASE,
      integrations: [Sentry.browserTracingIntegration()], // Sentry.replayIntegration()
      // Performance Monitoring
      tracesSampleRate: 0.2, //  Capture 20% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [DOMAIN],
      // Session Replay
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0.5,
      denyUrls: ['epub', 'fixedLayoutEditor', 'lib', 'visor', 'public'],

      // Solo agregar filtro para el error específico de NotFoundError
      beforeSend(event) {
        // Filtrar el error específico de NotFoundError en removeChild
        if (event.exception?.values) {
          const exception = event.exception.values[0];
          if (exception?.type === 'NotFoundError' && exception.value?.includes('removeChild')) {
            // Log del error para debugging local
            console.warn('NotFoundError filtrado en Sentry:', {
              error: exception.value,
              stack: exception.stacktrace,
              url: window.location.href,
              timestamp: new Date().toISOString(),
            });

            // No enviar este error a Sentry
            return null;
          }
        }

        return event;
      },
    });

    console.log(`%cSentry Init`, 'color: #007aff; font-weight: bold;');
  }
}

// Función helper simple para reportar errores manualmente
export function reportErrorToSentry(error, context = {}) {
  if (!process.env.REACT_APP_API_CONFIG_SENTRY) {
    return false;
  }

  try {
    return Sentry.captureException(error, {
      contexts: {
        custom: context,
      },
      tags: {
        source: 'manual_report',
        ...context.tags,
      },
    });
  } catch (sentryError) {
    console.error('Error al reportar a Sentry:', sentryError);
    return false;
  }
}

export function setSentryTenant(organization) {
  if (!process.env.REACT_APP_API_CONFIG_SENTRY) {
    return false;
  }

  const tenant = organization?.tenant;
  if (!tenant?.guid && !tenant?.name) {
    return false;
  }

  if (tenant?.guid) {
    Sentry.setTag('tenant_guid', tenant.guid);
  }

  if (tenant?.name) {
    Sentry.setTag('tenant_name', tenant.name);
  }

  Sentry.setContext('tenant', {
    guid: tenant?.guid,
    name: tenant?.name,
  });

  return true;
}
